import React from 'react';
import { Mail, ExternalLink } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { name: 'Courses', href: '/courses' },
    { name: 'Learning Paths', href: '/learning-paths' },
    { name: 'Terms & Conditions', href: '/terms' },
    { name: 'Privacy Policy', href: '/privacy' }
  ];

  const companyLinks = [
    { name: 'About Zero To Cloud', href: '/about' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container">
        <div className="py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Logo and Description */}
            <div>
              <h3 className="text-2xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-teal-400 bg-clip-text text-transparent">Zero To Cloud</h3>
              <p className="body-standard text-gray-300 mb-6 max-w-md">
                Zero to Cloud simplifies cloud learning with high quality materials covering certifications, hands-on projects, and career preparation.
              </p>
              
              <div className="flex items-center space-x-4">
                <div className="flex flex-col text-gray-300">
                  <div className="flex items-center mb-1">
                    <span className="text-red-400 text-xs mr-2">❤️</span>
                    <span>Made for Cloud Learners</span>
                  </div>
                  <div className="flex items-center">
                    <Mail className="mr-2 text-blue-400" size={18} />
                    <a 
                      href="mailto:hello@techwithlucy.com"
                      className="hover:text-blue-400 transition-colors"
                    >
                      hello@techwithlucy.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="heading-medium mb-6 text-blue-400">Quick Links</h4>
              <ul className="space-y-3">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <a 
                      href={link.href}
                      className="body-standard text-gray-300 hover:text-blue-400 transition-colors flex items-center"
                    >
                      {link.name}
                      <ExternalLink className="ml-1" size={14} />
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company */}
            <div>
              <h4 className="heading-medium mb-6 text-blue-400">Company</h4>
              <ul className="space-y-3">
                {companyLinks.map((link) => (
                  <li key={link.name}>
                    <a 
                      href={link.href}
                      className="body-standard text-gray-300 hover:text-blue-400 transition-colors flex items-center"
                    >
                      {link.name}
                      <ExternalLink className="ml-1" size={14} />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="body-small text-gray-400">
              Copyright © 2025 Zero To Cloud. All rights reserved.
            </p>
            
            <div className="flex items-center space-x-6 mt-4 md:mt-0">
              <a href="/terms" className="body-small text-gray-400 hover:text-blue-400 transition-colors">
                Terms
              </a>
              <a href="/privacy" className="body-small text-gray-400 hover:text-blue-400 transition-colors">
                Privacy
              </a>
              <a href="/cookies" className="body-small text-gray-400 hover:text-blue-400 transition-colors">
                Cookies
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;